import { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../../contexts/ContextProvider";
import { Loader } from "../../../../components";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  Button,
  Snackbar,
  Autocomplete,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { NumericFormat } from "react-number-format";
import useScreenWidth from "../../../../hooks/useScreenWidth";

const TambahStok = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [isStokExist, setIsStokExist] = useState(false);

  const [kodeStok, setKodeStok] = useState("");
  const [barcodeStok, setBarcodeStok] = useState("");
  const [namaStok, setNamaStok] = useState("");
  const [namaPanggilanStok, setNamaPanggilanStok] = useState("");
  const [merkStok, setMerkStok] = useState("");
  const [satuanKecilStok, setSatuanKecilStok] = useState("");
  const [satuanBesarStok, setSatuanBesarStok] = useState("");
  const [konversiStok, setKonversiStok] = useState("1");
  const [hargaJualStok, setHargaJualStok] = useState("0");
  const [kodeGroupStok, setKodeGroupStok] = useState("");
  const [stoksData, setStoksData] = useState([]);
  const [listStokRacikanChild, setListStokRacikanChild] = useState([]);

  const [groupStoks, setGroupStoks] = useState([]);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  let groupStokOptions = groupStoks.map((groupStok) => ({
    label: `${groupStok.kodeGroupStok} - ${groupStok.namaGroupStok}`,
  }));

  useEffect(() => {
    getGroupStokData();
    getStoksData();
  }, []);

  const getGroupStokData = async () => {
    const response = await axios.post(`${tempUrl}/groupStoks`, {
      _id: user.id,
      token: user.token,
    });
    setGroupStoks(response.data);
  };

  const getStoksData = async () => {
    const response = await axios.post(`${tempUrl}/stoks`, {
      _id: user.id,
      token: user.token,
    });
    setStoksData(response.data);
  };

  const getStokNextKode = async (kodeGroupStok) => {
    const response = await axios.post(`${tempUrl}/stoksNextKode`, {
      kodeGroupStok: kodeGroupStok.split(" ", 1)[0],
      _id: user.id,
      token: user.token,
    });
    setKodeStok(response.data);
  };

  const getFindStok = async (input) => {
    const response = await axios.post(`${tempUrl}/findStok`, {
      input,
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    if (response.data) {
      setIsStokExist(true);
      alert(
        `Data Barcode sudah ada dengan Kode Stok: ${response.data.kodeStok}, dan Nama Stok ${response.data.namaStok}`,
      );
    } else {
      setIsStokExist(false);
      alert(`Barcode belum ada`);
    }
  };

  const saveStok = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isStokExist) {
      alert(`Data tidak bisa disimpan karena barcode sudah ada!`);
      return;
    }

    const form = e.currentTarget;
    if (form.checkValidity() && kodeGroupStok.length !== 0) {
      setLoading(true);
      try {
        setLoading(true);
        const savedStok = await axios.post(`${tempUrl}/saveStok`, {
          barcodeStok,
          namaStok,
          namaPanggilanStok,
          merkStok,
          satuanKecilStok,
          satuanBesarStok,
          konversiStok,
          hargaJualStok,
          kodeGroupStok: kodeGroupStok.split(" ", 1)[0],
          userIdInput: user.id,
          _id: user.id,
          token: user.token,
        });
        const children = listStokRacikanChild
          .filter((item) => item.stokId)
          .map((item) => ({
            stokId: item.stokId,
            quantity: item.quantity === "" ? 0 : Number(item.quantity) || 0,
          }));
        if (children.length > 0) {
          await axios.post(`${tempUrl}/saveStokRacikan`, {
            namaStokRacikan: namaStok,
            stokId: savedStok.data.id,
            listStokRacikanChild: children,
            userIdInput: user.id,
            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          });
        }
        setLoading(false);
        navigate("/stok");
      } catch (error) {
        alert(error.response.data.message);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Master</h3>
      <h5 style={{ fontWeight: 400 }}>Tambah Stok</h5>
      <hr />
      <Card>
        <Card.Header>Stok</Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={saveStok}>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Group Stok <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={groupStokOptions}
                      renderInput={(params) => (
                        <TextField
                          error={error && kodeGroupStok.length === 0 && true}
                          size="small"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setKodeGroupStok(value.label);
                          getStokNextKode(value.label);
                        } else {
                          setKodeGroupStok("");
                        }
                      }}
                      value={kodeGroupStok}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Kode :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control required value={kodeStok} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Barcode :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={barcodeStok}
                      onChange={(e) => setBarcodeStok(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === "Tab") {
                          e.preventDefault();
                          // alert("Enter pressed on kodeStok");
                          getFindStok(e.target.value);
                        }
                      }}
                      style={{ textTransform: "uppercase" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Nama <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={namaStok}
                      onChange={(e) => {
                        setNamaStok(e.target.value);
                        setNamaPanggilanStok(e.target.value);
                      }}
                      style={{ textTransform: "uppercase" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Nama Panggilan :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={namaPanggilanStok}
                      onChange={(e) => setNamaPanggilanStok(e.target.value)}
                      style={{ textTransform: "uppercase" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Merk :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={merkStok}
                      onChange={(e) => setMerkStok(e.target.value)}
                      style={{ textTransform: "uppercase" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Satuan Kecil <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={satuanKecilStok}
                      onChange={(e) => {
                        setSatuanKecilStok(e.target.value);
                        setSatuanBesarStok(e.target.value);
                      }}
                      style={{ textTransform: "uppercase" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Satuan Besar :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      disabled
                      value={satuanBesarStok}
                      onChange={(e) => setSatuanBesarStok(e.target.value)}
                      style={{ textTransform: "uppercase" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Konversi <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      type="number"
                      value={konversiStok}
                      onChange={(e) => setKonversiStok(e.target.value)}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Harga Jual :
                  </Form.Label>
                  <Col sm="8">
                    <NumericFormat
                      disabled
                      value={hargaJualStok}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        // setHargaJualStok(
                        //   values.formattedValue
                        //     .split(".")
                        //     .join("")
                        //     .replace(/,/g, ""),
                        // );
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Card
              className="mt-4"
              style={{
                border: "1px solid #dbe7f3",
                borderRadius: 14,
                overflow: "hidden",
                boxShadow: "0 5px 18px rgba(25, 118, 210, 0.10)",
              }}
            >
              <Card.Header
                style={{
                  background: "linear-gradient(135deg, #1976d2, #42a5f5)",
                  color: "#fff",
                  fontWeight: 700,
                  letterSpacing: "0.2px",
                }}
              >
                Stok Racikan Item (Opsional)
              </Card.Header>
              <Card.Body style={{ backgroundColor: "#fbfdff" }}>
                <Button
                  variant="contained"
                  color="success"
                  type="button"
                  sx={{
                    mb: 1,
                    textTransform: "uppercase",
                    fontWeight: 700,
                    boxShadow: "0 3px 8px rgba(2, 136, 209, 0.25)",
                    bgcolor: "success.light",
                  }}
                  onClick={() =>
                    setListStokRacikanChild((current) => [
                      ...current,
                      { stokId: "", quantity: "", satuanKecilStok: "" },
                    ])
                  }
                >
                  + Input Stok Racikan Item
                </Button>
                <TableContainer
                  component={Paper}
                  className="mt-3"
                  sx={{
                    border: "1px solid #e2e8f0",
                    borderRadius: 2,
                    boxShadow: "0 2px 8px rgba(15, 23, 42, 0.08)",
                  }}
                >
                  <Table
                    size="small"
                    sx={{ minWidth: 760, tableLayout: "fixed" }}
                  >
                    <TableHead
                      sx={{
                        backgroundColor: "#1976d2",
                        "& .MuiTableCell-head": {
                          color: "#fff",
                          fontWeight: 700,
                        },
                      }}
                    >
                      <TableRow>
                        <TableCell sx={{ width: "56%" }}>Stok</TableCell>
                        <TableCell align="right" sx={{ width: "14%" }}>
                          Quantity
                        </TableCell>
                        <TableCell sx={{ width: "18%" }}>
                          Satuan Kecil
                        </TableCell>
                        <TableCell sx={{ width: "12%" }}>Hapus</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {listStokRacikanChild.map((child, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <Autocomplete
                              size="small"
                              options={stoksData}
                              value={
                                stoksData.find(
                                  (item) =>
                                    String(item.id) === String(child.stokId),
                                ) || null
                              }
                              getOptionLabel={(option) =>
                                option.kodeStok
                                  ? option.kodeStok + " - " + option.namaStok
                                  : ""
                              }
                              isOptionEqualToValue={(option, value) =>
                                String(option.id) === String(value.id)
                              }
                              onChange={(event, value) => {
                                child.stokId = value?.id || "";
                                child.satuanKecilStok =
                                  value?.satuanKecilStok || "";
                                setListStokRacikanChild([
                                  ...listStokRacikanChild,
                                ]);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  size="small"
                                  fullWidth
                                  placeholder="Cari stok..."
                                  {...params}
                                />
                              )}
                            />
                          </TableCell>
                          <TableCell align="right">
                            <NumericFormat
                              value={child.quantity}
                              decimalSeparator=","
                              thousandSeparator="."
                              customInput={Form.Control}
                              inputProps={{
                                style: { textAlign: "right" },
                              }}
                              onValueChange={(values) => {
                                child.quantity =
                                  values.value === ""
                                    ? ""
                                    : values.floatValue || 0;
                                setListStokRacikanChild([
                                  ...listStokRacikanChild,
                                ]);
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <Form.Control
                              value={child.satuanKecilStok || ""}
                              disabled
                              readOnly
                              style={{
                                backgroundColor: "#f1f5f9",
                                fontWeight: 600,
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <Button
                              variant="contained"
                              color="error"
                              type="button"
                              onClick={() =>
                                setListStokRacikanChild((current) =>
                                  current.filter(
                                    (_, childIndex) => childIndex !== index,
                                  ),
                                )
                              }
                            >
                              <DeleteOutlineIcon />
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card.Body>
            </Card>
            <Box sx={spacingTop}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate("/stok")}
                sx={{ marginRight: 2 }}
              >
                {"< Kembali"}
              </Button>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                type="submit"
              >
                Simpan
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default TambahStok;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const colorRed = {
  color: "red",
};
